/**
 * MonitorEDUQuickButtons Component
 *
 * A floating quick actions button that appears in the lower right corner of the screen.
 * Features:
 * - Hover tooltip showing "Quick Actions"
 * - Click to expand menu with predefined links
 * - Opens links in new tabs
 * - Uses Grommet's built-in Menu component for reliability
 *
 * Usage: Simply import and render this component in your app
 * It will automatically position itself in the lower right corner
 */

import React, { useState } from "react";
import { Box, Menu } from "grommet";
import { AppsRounded } from "grommet-icons";
import PodPaymentValidation from "./PodPaymentValidation";
import {
  usePodBookmarks,
  PodBookmarksViewer,
  PodBookmarkNotification,
} from "./PodBookmarks";

const MonitorEDUQuickButtons = ({
  property_link,
  referenceId,
  email,
  lastFour,
  user,
  podSession,
}) => {
  const [paymentValidation, setPaymentValidation] = useState(false);
  const {
    bookmarkSession,
    viewBookmarks,
    showNotification,
    setShowNotification,
    showViewer,
    setShowViewer,
  } = usePodBookmarks(podSession);

  const quickActions = [
    {
      label: "Payment Validation",
      onClick: () => {
        setPaymentValidation(true);
      },
    },
    {
      label: "New America Sheets",
      onClick: () => {
        window.open(
          "https://docs.google.com/spreadsheets/d/1pYu0Rra-60uwvn4AAjGX1Ccycq9qYC7LjFMvvpis_WI/edit?gid=0#gid=0",
          "_blank"
        );
      },
    },
    {
      label: "POD A",
      onClick: () => {
        window.open(
          "https://docs.google.com/spreadsheets/d/1KoJcDpg1T44oVXacmJ7BeLSE2Rdnl0b6WBiNl6Oye74/edit?gid=0#gid=0",
          "_blank"
        );
      },
    },
    {
      label: "POD B",
      onClick: () => {
        window.open(
          "https://docs.google.com/spreadsheets/d/1iIMDM90g4xfhRhkZg8okSWjMPOP90_2xuiK8yUdcWZo/edit?gid=0#gid=0",
          "_blank"
        );
      },
    },
    {
      label: "POD C",
      onClick: () => {
        window.open(
          "https://docs.google.com/spreadsheets/d/1YM95y7Iu1vuSRdvWtGK60zUY-V7WOS2QSxJ_vx7l2DA/edit?gid=0#gid=0",
          "_blank"
        );
      },
    },
    {
      label: "Property Tab",
      onClick: () => {
        window.open(property_link, "_blank");
      },
    },
    {
      label: "Batphone Support Line",
      onClick: () => {
        window.open("https://meet.google.com/otp-kgfc-zck", "_blank");
      },
    },
    {
      label: "Bookmark Session",
      onClick: bookmarkSession,
    },
    {
      label: "View Bookmarked Sessions",
      onClick: viewBookmarks,
    },
  ];

  return (
    <Box
      style={{
        position: "fixed",
        bottom: "20px",
        right: "0px",
        zIndex: 1000,
      }}
    >
      <Menu
        icon={<AppsRounded size="medium" color="white" />}
        items={quickActions}
        dropAlign={{ top: "bottom", right: "right" }}
        dropProps={{
          margin: { bottom: "50px", right: "0px" },
        }}
        tip="Quick Actions"
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "8px 0px 0px 8px",
          backgroundColor: "black",
        }}
      />
      {paymentValidation && (
        <PodPaymentValidation
          referenceId={referenceId}
          email={email}
          lastFour={lastFour}
          user={user}
          setPaymentValidation={setPaymentValidation}
        />
      )}
      <PodBookmarkNotification
        show={showNotification}
        onClose={() => setShowNotification(false)}
      />
      <PodBookmarksViewer
        isOpen={showViewer}
        onClose={() => setShowViewer(false)}
      />
    </Box>
  );
};

export default MonitorEDUQuickButtons;
